import { handleTypeConversion } from './handleTypeConversion';
export function handleTypeAssignment(context, fromNode, toNode) {
    const fromType = context.analysis.getType(fromNode);
    const toType = context.analysis.getType(toNode);
    handleTypeConversion(context, fromNode, fromType, toNode, toType);
}

//# sourceMappingURL=handleTypeAssignment.js.map
